<template>
  <div class="edit-staff--container">
    <div class="edit-staff--form">
      <form @submit.prevent="updateStaff">
        <div class="input-block text-center edit-staff--link">
          <div>
            <span><b>Личная ссылка для просмотра своего расписания:</b></span>
            <br>
            <span><a :href="staff.link" target="_blank">{{staff.link}}</a></span>
          </div>
          <div>
            <div @click="generateNewLink" class="btn btn-sm btn-outline-info">Сгенерировать новую ссылку</div>
          </div>
        </div>
        <div class="input-block">
          <label for="edit_staff_name"
            >Имя сотрудника <span class="req">*</span></label
          >
          <input
            type="text"
            @focus="staff.name.error = ''"
            @blur="vProfession"
            v-model="staff.name.model"
            id="edit_staff_name"
          />
          <div class="form-error">{{ staff.name.error }}</div>
          <div class="hint">
            Внимание! Не меняйте одного сотрудника на другого. Например, если у вас работал
            один стилист, уволился, на его место пришел другой и вы решили не создавать нового сотрудника,
            а просто изменить имя, то учитывайте, что во всех отчетах, статистиках, расчете зарплат и т.д
            для нового сотрудника будут учитываться записи, график работы и прочая история старого сотрудника.
          </div>
        </div>
        <div class="input-block">
          <label for="edit_staff_profession"
            >Специальность <span class="req">*</span></label
          >
          <input
            type="text"
            @focus="staff.profession.error = ''"
            @blur="vProfession"
            v-model="staff.profession.model"
            id="edit_staff_profession"
          />
          <div class="hint">
            Специальность. Например: "Мастер ногтевого сервиса"
          </div>
          <div class="form-error">{{ staff.profession.error }}</div>
        </div>
        <div class="edit-staff--avatar">
          <div class="staff--avatar-img">
            <img :src="croppieData.image" />
          </div>
          <div class="input-block">
            <label class="btn btn-sm btn-info" for="edit--staff-avatar"
              >Изменить изображение...</label
            >
            <input id="edit--staff-avatar" type="file" @change="changePhoto" />
            <div @click="deleteAvatar" class="btn btn-sm btn-danger">
              Удалить
            </div>
          </div>
        </div>
        <div class="staff--simple-select">
          <div>Выберите услуги, которые выполняет сотрудник: <span class="text-danger">*</span></div>
          <service-list-for-new-staff
            :data="servList"
            :default-services="slfns.default.services"
            :default-modifications="slfns.default.modifications"
            @checked="updateCheckServList"
          ></service-list-for-new-staff>
        </div>
        <div class="mrg-t-30"></div>
        <div class="input-block">
          <label>
            <input type="checkbox" v-model="staff.link_status">
            Включить личную ссылку просмотра расписания
          </label>
        </div>
        <div class="input-block">
          <label>Какие данные у записей может видеть сотрудник по личной ссылке</label>
          <select v-model="staff.link_permission_id">
            <option value="0">Только время</option>
            <option value="1">Время, имя клиента</option>
            <option value="2">Время, услуги</option>
            <option value="3">Время, имя клиента, услуги</option>
            <option value="4">Время, имя клиента, услуги, комментарий компании</option>
          </select>
        </div>
        <div class="input-block">
          <label>Какие данные записей присылает telegram-бот (если привязан)</label>
          <select v-model="staff.telegram_permission_id">
            <option value="0">Все данные о записи</option>
            <option value="1">Все, кроме номера телефона</option>
          </select>
        </div>
        <div class="input-block">
          <label>
            <input type="checkbox" v-model="staff.block_sms">
            Не отправлять СМС клиенту, если запись к данному сотруднику
          </label>
        </div>
        <div class="input-block">
          <label>
            <input type="checkbox" v-model="staff.hide">
            Скрыть сотрудника на странице записи
          </label>
          <div class="hint">
            При выборе данного пункта, сотрудник не будет отображаться на странице записи онлайн,
            но в разделе "Журнал записей" вы сможете с ним работать
          </div>
        </div>
        <div class="input-block">
          <button type="submit" class="btn btn-sm btn-success">
            Сохранить
          </button>
        </div>
      </form>
    </div>

    <popup
      :closeButton="deletePopup.closeButton"
      :actionButton="deletePopup.actionButton"
      :actionClass="deletePopup.actionClass"
      :show="deletePopup.show"
      @closePopup="closeDeletePopup"
      @actionPopup="deleteSubmit"
    >
      <div slot="header">Подтвердить удаление?</div>
      <div slot="body">
        Изображение сотрудника будет удалено из системы
      </div>
    </popup>
  </div>
</template>

<script>
import Validator from "../../libraries/Validator";
import Popup from "../../Popup";
import ServiceListForNewStaff from "./ServiceListForNewStaff";
import staffRepository from "../../../repositories/staff";

const validator = new Validator();

export default {
  name: "EditStaff",
  components: {ServiceListForNewStaff, Popup},
  data() {
    return {
      staff: {
        name: { model: "", error: "" },
        profession: { model: "", error: "" },
        link_status: false,
        link_permission_id: 0,
        telegram_permission_id: 0,
        block_sms: 0,
        hide: 0,
        link: ""
      },
      slfns:{
        default: {
          services: [],
          modifications: []
        },
        selectedServices: []
      },
      simpleSelect: {
        categoriesList: [],
        resetSimpleSelect: false,
        selectedCategories: [],
        default: []
      },
      deletePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      getOneStaffFlag: false
    };
  },
  props: {
    id: String,
    servList: Array,
    show: Boolean,
    croppieData: Object
  },
  watch: {
    id: function(val){
      this.getOneStaff(val);
    },
    show: function(val) {
      if(val && +this.id > 0){
        this.getOneStaff(this.id);
      }
    }
  },
  computed: {
    validateAll() {
      let errorCount = 0;
      this.vProfession().result == "error" ? errorCount++ : "";
      this.vName().result == "error" ? errorCount++ : "";
      return errorCount;
    }
  },
  methods: {
    getOneStaff(id){
      if(!this.getOneStaffFlag){
        this.getOneStaffFlag = true;
        this.$store.dispatch("startPreloader");

        staffRepository.getOneStaff({id: id}).then(resp => {
          this.getOneStaffFlag = false;
          this.staff.profession.model = resp.data.profession;
          this.staff.link_status = +resp.data.link_status;
          this.staff.link_permission_id = resp.data.link_permission_id;
          this.staff.telegram_permission_id = resp.data.telegram_permission_id;
          this.staff.block_sms = +resp.data.block_sms;
          this.staff.hide = +resp.data.hide;
          this.staff.link = resp.data.link;
          this.staff.name.model = resp.data.name;
          this.$emit('setCroppieImage', this.returnUpdatedImgLink(resp.data.avatar));
          this.setSLFNSDefault(resp.data.staffToServices);
          this.$emit('setCroppieImageBase', null);
          this.$store.dispatch("stopPreloader");
        }).catch(err => {
          this.$store.dispatch("addNotification", {
            text: err.response.data.message,
            time: 6,
            color: "danger"
          });
          this.$store.dispatch("stopPreloader");
        });
      }
    },
    generateNewLink(){
      this.$store.dispatch("startPreloader");

      staffRepository.generateNewLink({id: this.id}).then(resp => {
        this.staff.link = resp.data.link;
        this.$emit("updateStaff", resp.data);
        this.$store.dispatch("addNotification", {
          text: "Ссылка изменена",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    returnUpdatedImgLink(link) {
      let now = new Date();
      return link + "?update=" + now.getTime();
    },
    updateStaff() {
      if (this.validateAll) {
        return false;
      }
      if (!this.slfns.selectedServices.selectedServices.length && !this.slfns.selectedServices.selectedModifications.length) {
        this.$store.dispatch("addNotification", {
          text: "Не заданы услуги для изменяемого сотрудника",
          time: 5,
          color: "danger"
        });
        return false;
      }
      this.$store.dispatch("startPreloader");

      const data = {
        id: this.id,
        profession: this.staff.profession.model,
        name: this.staff.name.model,
        services: JSON.stringify(this.slfns.selectedServices),
        link_status: this.staff.link_status,
        link_permission_id: this.staff.link_permission_id,
        telegram_permission_id: this.staff.telegram_permission_id,
        block_sms: this.staff.block_sms,
        hide: this.staff.hide,
        avatar: this.croppieData.imageBase
      };

      staffRepository.updateStaff(data).then(resp => {
        this.$emit("updateStaff", resp.data);
        this.$store.dispatch("addNotification", {
          text: "Данные обновлены",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    deleteAvatar() {
      this.deletePopup.show = true;
    },
    deleteSubmit() {
      this.$store.dispatch("startPreloader");

      staffRepository.deleteAvatar({id: this.id}).then(resp => {
        this.$emit("updateStaff", resp.data);
        this.$emit('setCroppieImage', this.returnUpdatedImgLink(resp.data.avatar));
        this.deletePopup.show = false;
        this.$store.dispatch("addNotification", {
          text: "Изображение удалено",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.deletePopup.show = false;
        this.$store.dispatch("stopPreloader");
      });
    },
    vName() {
      let vName = validator.validate([
        {
          fieldName: "Имя сотрудника",
          value: this.staff.name.model,
          type: "required"
        },
        {
          fieldName: "Имя сотрудника",
          value: this.staff.name.model,
          type: "string",
          length: 255
        }
      ]);
      vName.result == "error"
        ? (this.staff.name.error = vName.message)
        : (this.staff.name.error = "");
      return vName;
    },
    vProfession() {
      let vProfession = validator.validate([
        {
          fieldName: "Специальность",
          value: this.staff.profession.model,
          type: "required"
        },
        {
          fieldName: "Специальность",
          value: this.staff.profession.model,
          type: "string",
          length: 255
        }
      ]);
      vProfession.result == "error"
        ? (this.staff.profession.error = vProfession.message)
        : (this.staff.profession.error = "");
      return vProfession;
    },
    changePhoto(file) {
      this.$emit('changePhoto', file);
    },
    updateCheckServList(val){
      this.slfns.selectedServices = val;
    },
    setSLFNSDefault(val) {
      let resultServices = [];
      let resultModifications = [];
      for (let key in val) {
        if(+val[key].modification_id > 0){
          resultModifications[resultModifications.length] = val[key].modification_id;
        }else{
          resultServices[resultServices.length] = val[key].service_id;
        }
      }
      this.slfns.default.services = resultServices;
      this.slfns.default.modifications = resultModifications;
    },
    closeDeletePopup() {
      this.deletePopup.show = false;
    }
  }
};
</script>

<style scoped lang="less">
.edit-staff--container {
  .hint {
    font-size: 13px;
    color: gray;
  }
}
.edit-staff--form {
  margin-top: 15px;
}
.edit-staff--avatar {
  text-align: center;

  img {
    width: 130px;
  }
}
.staff--simple-select {
  margin-bottom: 20px;

  h3 {
    margin-bottom: 8px;
  }
}
.edit-staff--link{
  &>div:nth-of-type(1){

    &>span:nth-of-type(2){
      text-decoration: underline;
      font-size: 13px;
    }
  }
  &>div:nth-of-type(2){
    margin-top: 5px;
  }
}
</style>
